document.addEventListener('DOMContentLoaded', function() {
  const headerWrapper = document.querySelector('.header-wrapper');
  const transparentClass = 'header--transparent-on-top';
  const scrollThreshold = 100; 

  if (!headerWrapper || !headerWrapper.classList.contains(transparentClass)) {
    return;
  }

  /**
   * 
   * @param {boolean} shouldBeTransparent - trueならクラスを付与
   */
  function updateHeaderTransparency(shouldBeTransparent) {
    headerWrapper.classList.toggle(transparentClass, shouldBeTransparent);
  }

  window.addEventListener('scroll', function() {
    const isScrolled = window.scrollY > scrollThreshold;
    updateHeaderTransparency(!isScrolled);
  });


  headerWrapper.addEventListener('mouseenter', function() {
    updateHeaderTransparency(false); 
  });

  headerWrapper.addEventListener('mouseleave', function() {
    const isAtTop = window.scrollY <= scrollThreshold;
    updateHeaderTransparency(isAtTop);
  });
});